import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';



interface LoadingElementProps {
	size?: number
}


const LoadingElement = (props: LoadingElementProps) => {
	const { size = 3 } = props;

	return (
		<div className="lfmt-loading loading-element" style={{ fontSize: `${size}rem`}}>
			
			<FontAwesomeIcon className="loading-icon fa-spin" icon={faSpinner} />

		</div>
	);
};

export default LoadingElement;